import { API_GET_JUDGMENT_LIST } from "../../constants/api";
import API from "..";

export const fetchJudgmentData = async ({
  workflowId,
  startDate,
  endDate,
  undetermined,
  approved,
  rejected,
  page,
  perPage,
  sort
}) => {
  try {
    const response = await API.get(API_GET_JUDGMENT_LIST, {
      params: {
        workflow_id: workflowId,
        start_date: startDate,
        end_date: endDate,
        undetermined: undetermined,
        approved: approved,
        rejected: rejected,
        page: page,
        per_page: perPage,
        sort: sort,
      },
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};